import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <div className="myFooter">
      <ul>
      <li><div className="logo"></div></li>
      </ul>
      <ul>
        <li>From today's mini crossword with ❤️</li>
        <li>Copyright © {year}</li>
      </ul>
    </div>
  );
};

export default Footer;
